// extracted by mini-css-extract-plugin
export default {"container":"styles_container__giSz3","title":"styles_title__6NEOM","label":"styles_label__lJygL","row":"styles_row__LyMKc"};